import styled from "styled-components";
import mainVisual01 from "../../img/main/main_visual01.jpg";
import mainVisual02 from "../../img/main/main_visual02.jpg";
import mainVisual03 from "../../img/main/main_visual03.jpg";
import { useEffect, useRef, useState } from "react";

const images = [mainVisual01, mainVisual02, mainVisual03];

interface HomeVisualProps {
  startSlides: boolean;
}

export default function HomeVisual({ startSlides }: HomeVisualProps) {
  const [current, setCurrent] = useState(0);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!startSlides) return; // 인트로가 끝나지 않았으면 슬라이드 시작하지 않음
    
    const delay = 5000; // 모든 슬라이드를 5초로 통일
    timeoutRef.current = setTimeout(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, delay);
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [current, startSlides]);

  return (
    <MainVisualSection>
      <VisualSectionBg src={mainVisual01} alt="main visual" />
      {images.map((src, idx) => (
        <FadeSlide
          key={src}
          $active={idx === current}
          $isFirst={idx === 0}
          style={{
            zIndex: idx === current ? 2 : 1,
            pointerEvents: idx === current ? "auto" : "none",
          }}
        >
          <SlideImg src={src} alt={`main visual ${idx + 1}`} />
        </FadeSlide>
      ))}
    </MainVisualSection>
  );
}

const MainVisualSection = styled.section`
  background-color: transparent;
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  @media (max-width: 768px) {
    height: 55vh;
  }
`;

const VisualSectionBg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
`;

const FadeSlide = styled.div<{ $active: boolean; $isFirst?: boolean }>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: ${({ $active }) => ($active ? 1 : 0)};
  transition: opacity ${({ $active, $isFirst }) => 
    $isFirst && !$active ? '3s' : '1.5s'
  } cubic-bezier(0.4, 0, 0.2, 0.01);
  will-change: opacity;
  /* z-index와 pointer-events는 style prop에서 동적으로 적용 */
`;

const SlideImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;